module.exports = __webpack_public_path__ + "img/collection-diamondJewelryGold.8dfd61c.jpg";